import { store as customer } from './customer'
import { store as plan } from './plan'

export default {
    ...customer,
    ...plan
}